module.exports = __webpack_public_path__ + "img/icon_comment_3.a97cc18e.png";